import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import styled from "@emotion/styled"
import GridWrapper from "../../atoms/GridWrapper"
import Title from "../../atoms/Title"
import { colors } from "../../constants"

const Text = styled.span(
  {
    fontFamily: "Avenir Next",
    fontWeight: "bold",
    "@media (max-width:540px)": {
      fontSize: "22px",
    },
  },
  props => ({
    color: props.brown ? "#300" : colors.brand,
  })
)

export default class Vision extends Component {
  render() {
    return (
      <GridWrapper>
        <Grid style={{ padding: 20 }}>
          <Grid style={{ padding: 20 }}>
            <Title fontSize={45}>Vision</Title>
          </Grid>
          <Grid style={{ textAlign: "left" }}>
            <Text brown>
              片平ゼミは、ブランドマーケティングを研究の対象とする、東京大学経済学部の自主ゼミです。
            </Text>
            <br />
            <Text brown>
              丸の内にある片平先生のオフィスで輪読や発表を通して、ブランドという社会的・心理的・経済的現象を解明することを目指します。
            </Text>
          </Grid>
        </Grid>
      </GridWrapper>
    )
  }
}
